import { render, staticRenderFns } from "./TheBusinessRegister.vue?vue&type=template&id=4f2d5f57&scoped=true&"
import script from "./TheBusinessRegister.vue?vue&type=script&lang=js&"
export * from "./TheBusinessRegister.vue?vue&type=script&lang=js&"
import style0 from "./TheBusinessRegister.vue?vue&type=style&index=0&id=4f2d5f57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d5f57",
  null
  
)

export default component.exports